<template>
  <div :class="{ 'col-xs-12 col-sm-6 col-md-4': widgetTrackplusFlag}">
    <div :class="widgetTrackplusFlag ? 'widget-1': ''">
      <h3 class="title" v-if="panel && panel.active">
        <img src="/static/images/icons/track_plus_icon_blue.svg"  class="track_plus_icon_blue" />
        <span>Summary</span>
      </h3>
      <div class="col-md-12 col-xs-12 summary_row">
        <div class="summary col-md-12 col-xs-12">
          <div class="div-img">
            <img
              class="summary_registration"
              src="/static/images/icons/summary_registration.svg"
            />
          </div>
          <div
            class="col-xs-11 cursor-pointer heading"
            @click="goToLink('/layout/registration')"
          >
            Registrations
            <div class="heading_count">{{ registrationCount }}</div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xs-12 summary_row">
        <div class="summary col-md-12 col-xs-12">
          <div class="div-img">
            <img
              class="summary_registration"
              src="/static/images/icons/summary_devices.svg"
            />
          </div>
          <div
            class="col-xs-11 cursor-pointer heading"
            @click="goToLink('/layout/report/device')"
          >
            Devices
            <div class="heading_count">{{ devicesCount }}</div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xs-12 summary_row">
        <div class="summary col-md-12 col-xs-12">
          <div class="div-img">
            <img
              class="summary_registration"
              src="/static/images/icons/summary_country.svg"
            />
          </div>
          <div
            class="col-xs-11 cursor-pointer heading"
            @click="goToLink('/layout/report/country')"
          >
            Countries
            <div class="heading_count">{{ countriesCount }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['widgetTrackplusFlag', 'registrationCount', 'devicesCount', 'countriesCount', 'panel', 'isCombo'],
  methods: {
    goToLink(link) {
      this.$router.push(link);
    },
  },
};
</script>

<style scoped>
.widget-1 {
  min-height: 280px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.27);
  border-radius: 10px;
  background: #ffffff;
}
.dashboard-trackplus-cards .summary_row {
  padding-top: 14px;
  padding-bottom: 10px;
  border-bottom: none !important;
}
.dashboard-trackplus-cards .summary_row:first-of-type {
  padding-top: 14px;
}
.summary_row {
  padding-top: 20px;
  padding-bottom: 40px;
}
.summary_row:not(:last-child) {
  border-bottom: 0.7px solid #BDBDBD;
}
.dashboard-trackplus-cards .track_plus_icon_blue {
  width: 32px;
  height: 32px;
}
.summary {
  display: flex;
  padding-left: 0px;
  padding-right: 0px;
}
.dashboard-trackplus-cards .title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0B3C61;
  padding-left: 24px;
  margin-top: 0px;
  padding-top: 24px;
}
.title span {
  padding-left: 19px;
}
.dashboard-trackplus-cards .heading,
.dashboard-trackplus-cards .heading_count {
  font-weight: 400;
  font-size: 20px;
}
.summary_registration {
  margin-top: -2px;
}
.div-img {
  padding-left: 9px;
}
.heading {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0B3C61;
  display: inline;
  padding-right: 10px;
  padding-left: 19px;
}
.heading_count {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 26px;
  color: rgba(0, 0, 0, 0.7);
  float: right;
}
.cursor-pointer {
  cursor: pointer !important;
  word-break: break-all;
  white-space: normal;
}

.pd-24 {
  padding: 24px;
}

@media screen and (max-width: 767px) {
  .content-wrappper .widget-1 {
    margin-bottom: 20px !important;
  }
  .heading {
    padding-right: 0px;
  }
}
</style>
